// import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { compose, lifecycle } from 'recompose'
import { fetchMenuElement } from './menuAction'
import { makeSelectMenu } from '../elementSelectors'

export default () => compose(
  connect(
    () => {
      const selecctMenu = makeSelectMenu();
      return (state, props) => selecctMenu(state, props);
    },
    (dispatch) => bindActionCreators({ fetchMenuElement }, dispatch),
  ),
  /* eslint-disable no-shadow */
  lifecycle({
    componentDidMount() {
      const {
        elementId,
        api,
        fetchMenuElement,
        fetchStatus,
      } = this.props
      if (fetchStatus.isInitial) {
        fetchMenuElement(api, elementId)
      }
    },
  }),
)



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/redux/menu/withMenuElement.js